<template>
  <div class="background_box">
    <div class="laws_statute">
      <div class="case">
        <div class="advanced_search">
          <div class="carousel" style="">
            <!-- <WORD
            :data="wordsEchaets"
            v-if="!loadNode"
            @getTreeData="testData"
          ></WORD> -->
            <img
              src="../../../assets/imgs/素材/棕黄色logo.png"
              style="width: 50px"
              alt=""
            />
            <!-- <div
            ref="chart1"
            class="wor"
            style="width: 210px; height: 120px; margin-left: 20px"
          ></div> -->
          </div>
          <el-tabs style="margin: 0 0 0 12px">
            <div style="display: flex; position: relative">
              <el-input
                placeholder="请输入检索内容"
                v-model="input"
                class="input-with-select tit_input"
                @keyup.enter.native="newSearch"
                clearable
              >
                <el-select
                  v-model="select"
                  slot="prepend"
                  placeholder="请选择"
                  style="width: 110px"
                  class="titSelect"
                >
                  <el-option
                    label="标题"
                    value="title"
                    style="text-align: center"
                  ></el-option>
                  <el-option
                    label="全文"
                    value="content"
                    style="text-align: center"
                  ></el-option>
                  <el-option
                    label="发文字号"
                    value="caseid"
                    style="text-align: center"
                  ></el-option>
                </el-select>
              </el-input>

              <el-button
                type="warning"
                @click="newSearch"
                style="width: 80px"
                class="search_button"
                >检索</el-button
              >

              <el-button type="warning" @click="seniorCase" style=""
                >高级检索 >></el-button
              >
            </div>
            <div style="margin: 10px 0 0 0">
              <el-radio-group v-model="radio01" class="radio_css">
                <el-radio :label="'1'" @change="accuracy('1')"
                  >模糊检索</el-radio
                >
                <el-radio :label="'2'" @change="accuracy('2')"
                  >精准检索</el-radio
                >
              </el-radio-group>
            </div>
            <div class="conditions">
              <div class="condition">
                <span style="position: absolute">搜索条件</span>
                <span class="eltags">
                  <el-tag
                    closable
                    type="warning"
                    v-for="(item, ind) in regulations"
                    :key="ind + 'item'"
                    @close="handleClose(item.type, ind)"
                  >
                    <span v-if="item.type == 'input' && item.sel">
                      <span v-if="item.sel == 'title'">标题：</span>
                      <span v-if="item.sel == 'content'">全文：</span
                      ><span v-if="item.sel == 'caseid'">发文字号：</span></span
                    >
                    <span v-if="item.type == 'Eff'">效力级别：</span>
                    <span v-if="item.type == 'Pub'">发布部门：</span>
                    <span v-if="item.type == 'Time'">发布年份：</span>
                    <span v-if="item.type == 'Aging'">时效性：</span>
                    <span v-if="item.type == 'Reg'">法规类别：</span>
                    <span v-if="item.type == 'Topic'">专题分类：</span>
                    <span v-if="item.type == 'doc'">文书分类：</span>
                    <span>{{ item.name }}</span>
                  </el-tag></span
                >
              </div>
              <div class="savebtn">
                <i class="el-icon-delete" @click="remove">清空条件</i>
              </div>
            </div>
          </el-tabs>
        </div>
        <div class="box_botton" style="">
          <div class="box_left">
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              :default-openeds="openeds"
            >
              <!-- <el-submenu index="0">
              <template slot="title">
                <img
                  src="../../../assets/imgs/img_532508.png"
                  alt=""
                  style="width: 0.42rem; height: 0.50rem; margin-right: 0.25rem"
                />
                <span class="imgTitle" style="font-weight: 900; font-size: 0.30rem"
                  >相关提示</span
                >
              </template>
              <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div>
            </el-submenu> -->
              <el-submenu index="1" v-if="Eff_level.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/效力级别.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >效力级别</span
                  >
                </template>
                <!-- <div style="" v-if="Eff_level.length == 0">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="levelAll ? Eff_level : Eff_level.slice(0, 10)"
                    :props="level"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Eff_level')
                    "
                    class="region"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.name
                        }}</span
                        >({{ data.count }})</span
                      >
                      <!-- <span style="font-weight: 900 !important;"></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Eff_level.length > 10"
                    @click="showAll('Eff_level')"
                    v-show="levelShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="2" v-if="Thematic.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/专题分类.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >专题分类</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree"></div>
                <el-tree
                  :data="thematicAll ? Thematic : Thematic.slice(0, 10)"
                  :props="thematic"
                  v-loading="loadNode"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgb(250, 242, 234)"
                  @node-click="
                    (data, node, item) =>
                      briefClick(data, node, item, 'Thematic')
                  "
                  class="region"
                  style="padding-left: 20px"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span style="line-height: 20px">
                      <span style="font-weight: 900 !important">{{
                        data.name
                      }}</span
                      >({{ data.count }})</span
                    >
                    <!-- <span></span> -->
                  </span>
                </el-tree>
                <span
                  class="more"
                  v-if="Thematic.length > 10"
                  @click="showAll('Thematic')"
                  v-show="thematicShow"
                  >查看更多</span
                >
              </el-submenu>
              <el-submenu index="7" v-if="DocCategory.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/文书分类.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >文书分类</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="CategoryAll ? DocCategory : DocCategory.slice(0, 10)"
                    :props="catecgoryment"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'DocCategory')
                    "
                    class="region"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px">
                        <span style="font-weight: 900 !important">{{
                          data.name
                        }}</span>
                        ({{ data.count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Pub_Department.length > 10"
                    @click="showAll('Pub_Department')"
                    v-show="CategoryShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/发布部门.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >发布部门</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="
                      departmentAll
                        ? Pub_Department
                        : Pub_Department.slice(0, 10)
                    "
                    :props="department"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Pub_Department')
                    "
                    class="region cityClass"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.name
                        }}</span
                        >({{ data.count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Pub_Department.length > 10"
                    @click="showAll('Pub_Department')"
                    v-show="departmentShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>

              <el-submenu index="4" v-if="Timeliness.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/时效性.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >时效性</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="timelinesAll ? Timeliness : Timeliness.slice(0, 10)"
                    :props="timelines"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Timeliness')
                    "
                    class="region"
                    style="padding-left: 23px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.key
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Timeliness.length > 10"
                    @click="showAll('Timeliness')"
                    v-show="timelinesShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="5" v-if="Reg_Category.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/法规类别.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >法规类别</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="
                      categoryAll ? Reg_Category : Reg_Category.slice(0, 10)
                    "
                    :props="category"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Reg_Category')
                    "
                    class="region"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.name
                        }}</span
                        >({{ data.count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Reg_Category.length > 10"
                    @click="showAll('Reg_Category')"
                    v-show="categoryShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="6" v-if="Pub_Time.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/发布年份.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >发布年份</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="timeAll ? Pub_Time : Pub_Time.slice(0, 10)"
                    :props="time"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Pub_Time')
                    "
                    class="region"
                    style="padding-left: 23px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px">
                        <span style="font-weight: 900 !important">{{
                          data.key_as_string
                        }}</span
                        >({{ data.doc_count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Pub_Time.length > 10"
                    @click="showAll('Pub_Time')"
                    v-show="timeShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
            </el-menu>
          </div>
          <div class="box_right">
            <div class="box_right_top">
              <div style="display: flex">
                <span style="line-height: 40px"
                  ><span style="margin-right: 20px"
                    >共<span style="color: #cf8700">{{ totalCount }}</span
                    >篇</span
                  ></span
                >
                <div>
                  <span style="margin-right: 10px">法规类别</span>
                  <el-select
                    v-model="type_vue"
                    placeholder="请选择"
                    @change="laws_Type"
                    class="bac"
                  >
                    <el-option
                      v-for="item in lawsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span>{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div>
                <span style="margin-right: 10px" v-if="sortShow">分组</span>
                <el-select
                  v-model="group"
                  placeholder="请选择"
                  v-if="sortShow"
                  size="mini"
                  style="width: 95px"
                  @change="packet"
                  class="bac"
                >
                  <el-option
                    v-for="item in groupsType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </el-option>
                </el-select>

                <span style="margin: 0 10px" v-if="sortShow">排序方式</span>
                <el-select
                  v-model="valuesort"
                  placeholder="请选择"
                  v-if="sortShow"
                  size="mini"
                  style="width: 110px"
                  class="bac"
                >
                  <el-option
                    v-for="item in defaultsort"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span @click="itemsort(item.value, item.label)">{{
                      item.label
                    }}</span>
                  </el-option>
                </el-select>
                <el-button-group
                  style="margin-left: 20px"
                  class="types"
                  element-loading-spinner="el-icon-loading"
                  v-if="searchParameter.type !== '法律文书'"
                >
                  <el-button
                    @click="dataType('chart')"
                    :class="picked ? 'listPick' : 'EChart'"
                    >列表化</el-button
                  >
                  <el-button
                    @click="dataType('list')"
                    :class="picked ? 'EChart' : 'listPick'"
                    >可视化</el-button
                  >
                </el-button-group>
              </div>
            </div>
            <div
              class="box_main"
              v-loading="loading_box"
              v-if="picked"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="min-height: 500px"
              element-loading-background="rgba(255, 255, 255, 0.5)"
            >
              <div
                v-if="totalCount == 0 && categoryList.length <= 0"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 500px;
                "
              >
                <div>
                  <img src="../Case/kongkong.png" alt="" />
                  <div style="text-align: center; font-size: 20px">
                    暂无数据
                  </div>
                </div>
              </div>
              <div v-if="lawList.length > 0">
                <div
                  class="box_main_list"
                  v-for="(item, index) in lawList"
                  :key="index"
                >
                  <!-- /lawsDetail -->
                  <div class="title">
                    <router-link
                      :to="{
                        path: `/lawsDetail/${item._id}`,
                        query: {
                          type: item._source.type,
                          keyword: input,
                          radio: radio01,
                        },
                      }"
                      target="_blank"
                    >
                      <span style="position: absolute; top: 0px">{{
                        index + 1 + "、"
                      }}</span>
                      <span v-if="type_vue !== '法律文书'"
                        ><el-tag
                          v-if="
                            item._source.Timeliness == '现行有效' ||
                            item._source.Timeliness == '已被修改'
                          "
                          >{{ item._source.Timeliness }}</el-tag
                        >
                        <el-tag
                          type="info"
                          v-else-if="item._source.Timeliness == '尚未生效'"
                          >{{ item._source.Timeliness }}</el-tag
                        >
                        <el-tag
                          type="warning"
                          v-else-if="item._source.Timeliness == '部分失效'"
                          >{{ item._source.Timeliness }}</el-tag
                        >
                        <el-tag
                          type="danger"
                          v-else-if="item._source.Timeliness == '失效'"
                          >&ensp;失&emsp;效&ensp;</el-tag
                        >
                        <el-tag
                          type="info"
                          v-else
                          >{{item._source.Timeliness}}</el-tag
                        ></span
                      >
                      <h2
                        style="
                          display: inline-block;
                          font-weight: 500;
                          font-size: 16px;
                          cursor: pointer;
                          width: 800px;
                          word-break: normal;

                          line-height: 32px;
                        "
                        :style="
                          type_vue !== '法律文书'
                            ? 'margin-left: 100px;'
                            : 'margin-left: 16px;'
                        "
                        v-html="item._source.Title"
                      >
                        <!-- {{ item._source.Casename }} -->
                      </h2>
                    </router-link>
                    <div style="display: flex">
                      <div class="collection" v-if="!item._source.coll">
                        <el-tooltip
                          content="收藏"
                          placement="left"
                          effect="light"
                        >
                          <img
                            @click="collectible(item)"
                            src="../../../assets/imgs/2.0/_收藏.png"
                            alt=""
                          />
                        </el-tooltip>
                      </div>
                      <div class="collection" v-if="item._source.coll">
                        <el-tooltip
                          content="收藏"
                          placement="left"
                          effect="light"
                        >
                          <img
                            v-if="item._source.coll == 0"
                            @click="collectible(item)"
                            src="../../../assets/imgs/2.0/_收藏.png"
                            alt=""
                          />
                        </el-tooltip>
                        <el-popconfirm
                          title="确认取消收藏吗？"
                          @confirm="cancel(item)"
                        >
                          <img
                            slot="reference"
                            v-if="item._source.coll == 1"
                            src="../../../assets/imgs/2.0/收藏3.png"
                            alt=""
                          />
                        </el-popconfirm>
                      </div>
                      <el-dropdown style="height: 28px; margin: 0px 10px">
                        <!-- <el-button type="primary" size="mini" style="height: 28px"
                    >下载</el-button
                  > -->
                        <el-button
                          type="warning"
                          icon="el-icon-download"
                          circle
                          size="mini"
                        ></el-button>
                        <!-- <i class="el-icon-download"></i> -->
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            ><span @click="down(item._id, 'pdf')"
                              ><img
                                class="down_icon"
                                src="../../../assets/imgs/图标/pdf (1).png"
                                alt=""
                              />
                              PDF文件</span
                            ></el-dropdown-item
                          >
                          <el-dropdown-item
                            ><span @click="down(item._id, 'word')"
                              ><img
                                class="down_icon"
                                src="../../../assets/imgs/图标/word.png"
                                alt=""
                              />
                              WORD文件</span
                            ></el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>

                  <div style="margin: 10px 0 10px 25px" class="message">
                    <el-breadcrumb separator="/">
                      <el-breadcrumb-item>{{
                        item._source.Timeliness
                      }}</el-breadcrumb-item>
                      <el-breadcrumb-item v-if="item._source.Iss_Num">{{
                        item._source.Iss_Num
                      }}</el-breadcrumb-item>
                      <el-breadcrumb-item
                        >{{ item._source.Pub_Time }}发布</el-breadcrumb-item
                      >
                      <el-breadcrumb-item v-if="item._source.Imp_Time">{{
                        item._source.Imp_Time
                      }}</el-breadcrumb-item>
                    </el-breadcrumb>

                    <!-- <div style="margin: 10px 0">
                  <el-button size="mini" round>本法变迁</el-button>
                  <el-button size="mini" round>相关案例</el-button>
                  <el-button size="mini" round>引用统计</el-button>
                  <el-button size="mini" round>智能发现</el-button>
                </div> -->
                  </div>
                  <div class="card">
                    <el-tabs type="border-card" v-if="item._source.retrieval">
                      <el-tab-pane
                        v-if="item._source.retrieval.word_times"
                        :label="
                          '命中' +
                          '(' +
                          item._source.retrieval.word_times.times +
                          ')'
                        "
                      >
                        <div>
                          <div
                            v-for="(items, index) in item._source.retrieval.par"
                            :key="index + '04'"
                          >
                            <div class="hits">
                              <span
                                style="width: 800px; line-height: 25px"
                                v-html="items"
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div class="mores">
                          <router-link
                            :to="{
                              path: `/lawsDetail/${item._id}`,
                              query: {
                                type: item._source.type,
                                keyword: input,
                                radio: radio01,
                              },
                            }"
                            target="_blank"
                          >
                            <span>更多请查看原文</span>
                          </router-link>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <!-- <div class="box_detail"></div> -->
                  <el-divider></el-divider>
                </div>
                <div class="page-bar" v-if="picked">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount > 10000 ? 10000 : totalCount"
                    @current-change="handleCurrentChange"
                    :current-page.sync="current_page"
                    :page-size="20"
                  >
                  </el-pagination>
                </div>
              </div>
              <div style="margin-bottom: 20px" v-if="lawList.length == 0">
                <div
                  class="box_main_list"
                  v-for="(item_category, index) in categoryList"
                  :key="index"
                  style="margin: 0 0 20px 0"
                >
                  <div class="grouping-title">
                    <h3 @click="moreLevel(item_category.Maxti)">
                      {{ item_category.Maxti }}({{
                        item_category.list.total.value
                      }})
                    </h3>
                    <span
                      class="packMore"
                      @click="moreLevel(item_category.Maxti)"
                      >更多 >>
                    </span>
                  </div>

                  <div
                    class="box_main_list"
                    v-for="(item, index) in item_category.list.hits.slice(0, 8)"
                    :key="index"
                  >
                    <!-- /lawsDetail -->
                    <div class="title">
                      <router-link
                        :to="{
                          path: `/lawsDetail/${item._id}`,
                          query: {
                            type: item._source.type,
                            keyword: input,
                            radio: radio01,
                          },
                        }"
                        target="_blank"
                      >
                        <span style="position: absolute; top: 0px">{{
                          index + 1 + "、"
                        }}</span>
                        <span v-if="type_vue !== '法律文书'"
                          >
                          <el-tag
                            v-if="
                              item._source.Timeliness == '现行有效' ||
                              item._source.Timeliness == '已被修改'
                            "
                            >{{ item._source.Timeliness }}</el-tag
                          >
                         
                          <el-tag
                            type="warning"
                            v-else-if="item._source.Timeliness == '部分失效'"
                            >{{ item._source.Timeliness }}</el-tag
                          >
                          <el-tag
                            type="danger"
                            v-else-if="item._source.Timeliness == '失效'"
                            >&ensp;失&emsp;效&ensp;</el-tag
                          >
                           <el-tag
                            type="info"
                            v-else-if="item._source.Timeliness == '尚未生效'"
                            >{{ item._source.Timeliness }}</el-tag
                          >
                           <el-tag
                            type="info"
                            v-else
                            >{{ item._source.Timeliness }}</el-tag
                          >
                          </span
                        >

                        <h2
                          style="
                            display: inline-block;
                            font-weight: 500;
                            font-size: 16px;
                            cursor: pointer;
                            width: 800px;
                            word-break: normal;

                            line-height: 32px;
                          "
                          :style="
                            type_vue !== '法律文书'
                              ? 'margin-left: 100px;'
                              : 'margin-left: 16px;'
                          "
                          v-html="item._source.Title"
                        >
                          <!-- {{ item._source.Casename }} -->
                        </h2>
                      </router-link>
                      <div style="display: flex">
                        <div class="collection" v-if="!item._source.coll">
                          <el-tooltip
                            content="收藏"
                            placement="left"
                            effect="light"
                          >
                            <img
                              @click="collectible(item)"
                              src="../../../assets/imgs/2.0/_收藏.png"
                              alt=""
                            />
                          </el-tooltip>
                        </div>
                        <div class="collection" v-if="item._source.coll">
                          <el-tooltip
                            content="收藏"
                            placement="left"
                            effect="light"
                          >
                            <img
                              v-if="item._source.coll == 0"
                              @click="collectible(item)"
                              src="../../../assets/imgs/2.0/_收藏.png"
                              alt=""
                            />
                          </el-tooltip>
                          <el-popconfirm
                            title="确认取消收藏吗？"
                            @confirm="cancel(item)"
                          >
                            <img
                              slot="reference"
                              v-if="item._source.coll == 1"
                              src="../../../assets/imgs/2.0/收藏3.png"
                              alt=""
                            />
                          </el-popconfirm>
                        </div>
                        <el-dropdown style="height: 28px; margin: 0px 10px">
                          <!-- <el-button type="primary" size="mini" style="height: 28px"
                    >下载</el-button
                  > -->
                          <el-button
                            type="warning"
                            icon="el-icon-download"
                            circle
                            size="mini"
                          ></el-button>
                          <!-- <i class="el-icon-download"></i> -->
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              ><span @click="down(item._id, 'pdf')"
                                ><img
                                  class="down_icon"
                                  src="../../../assets/imgs/图标/pdf (1).png"
                                  alt=""
                                />
                                PDF文件</span
                              ></el-dropdown-item
                            >
                            <el-dropdown-item
                              ><span @click="down(item._id, 'word')"
                                ><img
                                  class="down_icon"
                                  src="../../../assets/imgs/图标/word.png"
                                  alt=""
                                />
                                WORD文件</span
                              ></el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <div style="margin: 10px 0 10px 25px" class="message">
                      <el-breadcrumb separator="/">
                        <el-breadcrumb-item>{{
                          item._source.Timeliness
                        }}</el-breadcrumb-item>
                        <el-breadcrumb-item v-if="item._source.Iss_Num">{{
                          item._source.Iss_Num
                        }}</el-breadcrumb-item>
                        <el-breadcrumb-item
                          >{{ item._source.Pub_Time }}发布</el-breadcrumb-item
                        >
                        <el-breadcrumb-item v-if="item._source.Imp_Time">{{
                          item._source.Imp_Time
                        }}</el-breadcrumb-item>
                      </el-breadcrumb>

                      <!-- <div style="margin: 10px 0">
                  <el-button size="mini" round>本法变迁</el-button>
                  <el-button size="mini" round>相关案例</el-button>
                  <el-button size="mini" round>引用统计</el-button>
                  <el-button size="mini" round>智能发现</el-button>
                </div> -->
                    </div>
                    <div class="card">
                      <el-tabs type="border-card" v-if="item._source.retrieval">
                        <el-tab-pane
                          v-if="item._source.retrieval.word_times"
                          :label="
                            '命中' +
                            '(' +
                            item._source.retrieval.word_times.times +
                            ')'
                          "
                        >
                          <div>
                            <div
                              v-for="(items, index) in item._source.retrieval
                                .par"
                              :key="index + '04'"
                            >
                              <div class="hits">
                                <span
                                  style="width: 800px; line-height: 25px"
                                  v-html="items"
                                ></span>
                              </div>
                            </div>
                          </div>

                          <div class="mores">
                            <router-link
                              :to="{
                                path: `/lawsDetail/${item._id}`,
                                query: {
                                  type: item._source.type,
                                  keyword: input,
                                  radio: radio01,
                                },
                              }"
                              target="_blank"
                            >
                              <span>更多请查看原文</span>
                            </router-link>
                          </div>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                    <!-- <div class="box_detail"></div> -->
                    <el-divider></el-divider>
                  </div>
                  <!-- <div class="more" v-if="item_category.list.hits.length > 7">
                  <el-button
                    class="packMore"
                    type="text"
                    icon="el-icon-view"
                    @click="moreLevel(item_category.Maxti)"
                    >更多</el-button
                  >
                </div> -->
                </div>
              </div>
            </div>
            <div
              class="ECharts_main"
              v-loading="loadNode"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="min-height: 500px; margin: 10px 0"
              element-loading-background="rgba(255, 255, 255, 0.5)"
              v-if="!picked"
            >
              <CHART
                :eChars="leftData"
                v-loading="loadNode"
                v-if="update"
              ></CHART>
            </div>
          </div>
        </div>
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>

<script>
import store from "@/store";

import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
import CHART from "./component/charts.vue";
import WORD from "./component/word.vue";
import ComFooter from "../../../components/ComFooter.vue";
export default {
  components: {
    CHART,
    ComFooter,
    WORD,
  },
  data() {
    return {
      update: true,
      openeds: ["1", "2", "3", "4", "5", "6", "7"], //侧边栏
      radio01: "1", //精准 / 模糊检索
      select: "title",
      input: "", //检索框
      searchParameter: {
        page: 1,
        pagesize: 20,
        search: "", //文本框检索
        iss_num: "", //发文字号
        pub_time: "", //发布日期
        imp_time: "", //实施日期
        timeliness: "", //时效性
        eff_level: "", //效力级别
        reg_category: "", //法规类别
        failure_basis: "", //失效依据
        content: "", //全文
        pub_department: "", //发布部门
        title: "", //标题
        thematic_class: "", //专题分类
        iss_num: "", //发文字号
        type: "", //类型：中央法规；地方法规 ;法律文书
        order: "", //排序
        // group_by:"效力级别"
        doc_category: "",
      },
      type_vue: "中央法规",
      search_Vue: { word: "", type: "1", field: "title" }, //文本框检索
      pub_time_Vue: { start: "", end: "" }, //发布日期
      imp_time_Vue: { start: "", end: "" }, //实施日期
      order_vue: { field: "Imp_Time", type: "desc" }, //排序方式

      //   筛选数据
      Eff_level: [], //效力级别
      Pub_Department: [], //发布部门
      Pub_Time: [], //发布年份
      Reg_Category: [], //法规类别
      Thematic: [], //专题分类
      Timeliness: [], //时效性
      DocCategory: [], //文书分类
      level: {
        children: "children",
        label: "key",
      },
      levelAll: false,
      levelShow: true,
      department: {
        children: "children",
        label: "key",
      },
      CategoryAll: false,
      CategoryShow: true,
      catecgoryment: {
        children: "children",
        label: "key",
      },
      departmentAll: false,
      departmentShow: true,
      thematic: {
        children: "children",
        label: "key",
      },
      thematicAll: false,
      thematicShow: true,
      timelines: {
        children: "children",
        label: "key",
      },
      timelinesAll: false,
      timelinesShow: true,
      category: {
        children: "children",
        label: "key",
      },
      categoryAll: false,
      categoryShow: true,
      time: {
        children: "children",
        label: "key",
      },
      timeAll: false,
      timeShow: true,
      loadNode: true,
      totalCount: 0, //检索结果数量
      sortShow: true,
      group: "效力级别",
      groupsType: [
        {
          value: "效力级别",
          label: "效力级别",
        },
        {
          value: "时效性",
          label: "时效性",
        },
        {
          value: "",
          label: "不分组",
        },
      ],
      valuesort: "desc0",
      defaultsort: [
        {
          value: "asc",
          label: "↑ 发布时间",
        },
        {
          value: "desc",
          label: "↓ 发布时间",
        },
        {
          value: "asc0",
          label: "↑ 实施时间",
        },
        {
          value: "desc0",
          label: "↓ 实施时间",
        },
      ],
      defaultsort01: [
        {
          value: "",
          label: "相关度",
        },
        {
          value: "asc",
          label: "↑ 发布时间",
        },
        {
          value: "desc",
          label: "↓ 发布时间",
        },
        {
          value: "asc0",
          label: "↑ 实施时间",
        },
        {
          value: "desc0",
          label: "↓ 实施时间",
        },
      ],
      picked: true,
      lawList: "",
      loadNode: true,
      loading_box: true,
      regulations: [], //检索、筛选条件
      leftData: "",
      lawsType: [
        {
          value: "中央法规",
          label: "中央法规",
        },
        {
          value: "地方法规",
          label: "地方法规",
        },
        {
          value: "法律文书",
          label: "法律文书",
        },
      ],
      current_page: 1,
      categoryList: [],
      wordsEchaets: [],
    };
  },
  created() {
    if (window.sessionStorage.getItem("laws")) {
      window.sessionStorage.removeItem("laws");
      // let retain = JSON.parse(window.sessionStorage.getItem("laws"));
      // this.regulations = retain;

      // retain.forEach((item) => {
      //   if (item.type == "input") {
      //     // this.simpleSearch = JSON.parse(this.simpleSearch);
      //     this.search_Vue.word = item.name;
      //   }
      //   if (item.type == "Eff") {
      //     this.searchParameter.eff_level = JSON.stringify([item.name]);
      //   }
      //   if (item.type == "Pub") {
      //     this.searchParameter.pub_department = JSON.stringify([item.name]);
      //   }
      //   if (item.type == "Time") {
      //     // this.searchParameter.pub_time = item.name;
      //     this.pub_time_Vue = {
      //       start: item.name + "-01-01",
      //       end: item.name + "-12-31",
      //     };
      //   }
      //   // if (item.type == "Time") {
      //   //   this.publish_time = item.name;
      //   //   if (item.end) {
      //   //     this.publish_endTime = item.name;
      //   //     this.pub_time_Vue = {
      //   //       start: item.name + "-01-01",
      //   //       end: item.end + "-12-31",
      //   //     };
      //   //   } else {
      //   //     this.pub_time_Vue = {
      //   //       start: item.name + "-01-01",
      //   //       end: item.name + "-12-31",
      //   //     };
      //   //   }
      //   // }
      //   if (item.type == "Reg") {
      //     this.searchParameter.reg_category = JSON.stringify([item.name]);
      //   }
      //   if (item.type == "Topic") {
      //     this.searchParameter.thematic_class = JSON.stringify([item.name]);
      //   }
      //   if (item.type == "Aging") {
      //     this.searchParameter.timeliness = JSON.stringify([item.name]);
      //   }
      //   if (item.type == "doc") {
      //     this.group = "文书分类";
      //     this.type_vue = "法律文书"
      //     this.groupsType = [
      //       {
      //         value: "文书分类",
      //         label: "文书分类",
      //       },
      //       {
      //         value: "",
      //         label: "不分组",
      //       },
      //     ];
      //     this.searchParameter.doc_category = JSON.stringify([item.name]);
      //   }
      // });
    }
    this.statuteList();
    this.statuteSift();
  },
  methods: {
    //   获取法律法规列表数据
    statuteList() {
      this.searchParameter.search = JSON.stringify(this.search_Vue);
      this.searchParameter.pub_time = JSON.stringify(this.pub_time_Vue);
      this.searchParameter.imp_time = JSON.stringify(this.imp_time_Vue);
      this.searchParameter.order = JSON.stringify(this.order_vue);
      this.searchParameter.type = JSON.stringify([this.type_vue]);
      // this.$http
      //   .post("/lawreg", this.searchParameter)
      //   .then((res) => {
      //     // console.log(res);
      //     this.totalCount = res.data.data.list.total.value;
      //     this.lawList = res.data.data.list.hits;
      //     this.loading_box = false;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
      this.$set(this.searchParameter, "group_by", this.group);
      this.$http
        .post("/newlawreg", this.searchParameter)
        .then((res) => {
          // console.log(res);
          if (this.searchParameter.group_by == "") {
            // console.log("a");
            this.totalCount = res.data.data.list.total.value;
            this.lawList = res.data.data.list.hits;
            this.loading_box = false;
          } else {
            // console.log(res.data.data.length);
            if (res.data.data.length == 1) {
              //  console.log('a')
              this.categoryList = [];
              this.totalCount = res.data.data[0].list.total.value;
              this.lawList = res.data.data[0].list.hits;
              this.loading_box = false;
            } else {
              this.lawList = [];
              //  console.log('a')
              this.categoryList = res.data.data;
              this.loading_box = false;
              this.totalCount = 0;
              this.categoryList.forEach((item) => {
                this.totalCount = this.totalCount + item.list.total.value;
              });
            }
            // if (
            //   this.searchParameter.timeliness == "" &&
            //   this.searchParameter.eff_level == "" &&
            //   this.searchParameter.reg_category == "" &&
            //   this.searchParameter.pub_department == "" &&
            //   this.searchParameter.thematic_class == ""
            // ) {
            //   this.lawList = [];
            //   this.categoryList = res.data.data;
            //   this.loading_box = false;
            //   this.totalCount = 0;
            //   this.categoryList.forEach((item) => {
            //     this.totalCount = this.totalCount + item.list.total.value;
            //   });
            //   this.loading_box = false;
            // } else {
            //   this.totalCount = res.data.data[0].list.total.value;
            //   this.lawList = res.data.data[0].list.hits;
            //   this.loading_box = false;
            // }

            // console.log(this.totalCount);
          }
          this.loading_box = false;
          // this.totalCount =
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //   获取法律法规筛选数据
    statuteSift() {
      this.searchParameter.search = JSON.stringify(this.search_Vue);
      this.searchParameter.pub_time = JSON.stringify(this.pub_time_Vue);
      this.searchParameter.imp_time = JSON.stringify(this.imp_time_Vue);
      this.searchParameter.order = JSON.stringify(this.order_vue);
      this.searchParameter.type = JSON.stringify([this.type_vue]);

      if (this.searchParameter.hasOwnProperty("group_by")) {
        // delete this.searchParameter.group_by;
        this.searchParameter.group_by = this.group;
      } else {
        this.$set(this.searchParameter, "group_by", this.group);
      }

      this.$http
        .post("/regcategory", this.searchParameter)
        .then((res) => {
          // console.log(res);
          this.leftData = res.data.data;

          this.Eff_level = []; //效力级别

          this.Pub_Department = []; //发布部门

          this.Pub_Time = []; //发布年份

          this.Reg_Category = []; //法规类别

          this.Timeliness = []; //时效性
          this.Thematic = [];
          this.DocCategory = [];

          if (res.data.data.Eff_level) {
            this.Eff_level = res.data.data.Eff_level.filter(item => item.name !== ''); //效力级别
            // console.log(this.Eff_level);
          }
          if (res.data.data.Pub_Department) {
            this.Pub_Department = res.data.data.Pub_Department.filter(item => item.name !== ''); //发布部门
          }
          if (res.data.data.Pub_Time) {
            this.Pub_Time = res.data.data.Pub_Time.filter(item => item.key !== ''); //发布年份
          }
          if (res.data.data.Reg_Category) {
            this.Reg_Category = res.data.data.Reg_Category.filter(item => item.name !== ''); //法规类别
          }
          if (res.data.data.Thematic) {
            this.Thematic = res.data.data.Thematic.filter(item => item.name !== ''); //专题分类
          }

          if (res.data.data.Timeliness) {
            this.Timeliness = res.data.data.Timeliness.filter(item => item.key !== ''); //时效性
          }
          if (res.data.data.Doc_Category) {
            this.DocCategory = res.data.data.Doc_Category; //时效性
          }
          // this.showEeharts();
          this.wordsEchaets = [];
          this.Thematic.forEach((item, index) => {
            if (index <= 15) {
              let word = {
                name: item.name,
                value: item.count,
              };
              this.wordsEchaets.push(word);
            }
          });
          this.loadNode = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 检索框检索
    newSearch() {
      // console.log(this.input);
      this.search_Vue.word = this.input;
      this.search_Vue.field = this.select;
      this.searchParameter.page = 1;
      this.current_page = 1;
      this.loading_box = true;
      // this.statuteSift();
      this.regulations = [];
      window.sessionStorage.removeItem("laws");
      this.searchParameter = {
        page: 1,
        pagesize: 20,
        search: "", //文本框检索
        iss_num: "", //发文字号
        pub_time: "", //发布日期
        imp_time: "", //实施日期
        timeliness: "", //时效性
        eff_level: "", //效力级别
        reg_category: "", //法规类别
        failure_basis: "", //失效依据
        content: "", //全文
        pub_department: "", //发布部门
        title: "", //标题
        thematic_class: "", //专题分类
        iss_num: "", //发文字号
        type: "", //类型：中央法规；地方法规 ;法律文书
        order: "", //排序
        doc_category: "",
      };
      this.pub_time_Vue = { start: "", end: "" }; //发布日期
      if (this.input !== "") {
        let search_tag = {
          type: "input",
          name: this.input,
          sel: this.select,
        };
        this.regulations.push(search_tag);
        window.sessionStorage.setItem("laws", JSON.stringify(this.regulations));
        this.defaultsort = this.defaultsort01;
        this.valuesort = "";
      } else {
        window.sessionStorage.removeItem("laws");
      }
      if (this.type_vue == "法律文书") {
        this.group = "文书分类";
        this.groupsType = [
          {
            value: "文书分类",
            label: "文书分类",
          },
          {
            value: "",
            label: "不分组",
          },
        ];
        if (this.search_Vue.word !== "") {
          this.defaultsort = [
            {
              value: "",
              label: "相关度",
            },
            {
              value: "asc",
              label: "↑ 发布时间",
            },
            {
              value: "desc",
              label: "↓ 发布时间",
            },
          ];
          this.valuesort = "";
        } else {
          this.defaultsort = [
            {
              value: "asc",
              label: "↑ 发布时间",
            },
            {
              value: "desc",
              label: "↓ 发布时间",
            },
          ];
          this.valuesort = "desc";
        }
        // this.searchParameter.doc_category = "法律文书";
      } else {
        this.group = "效力级别";
        if (this.search_Vue.word !== "") {
          this.defaultsort = [
            {
              value: "",
              label: "相关度",
            },
            {
              value: "asc",
              label: "↑ 发布时间",
            },
            {
              value: "desc",
              label: "↓ 发布时间",
            },
            {
              value: "asc0",
              label: "↑ 实施时间",
            },
            {
              value: "desc0",
              label: "↓ 实施时间",
            },
          ];
          this.valuesort = "";
        } else {
          this.defaultsort = [
            {
              value: "asc",
              label: "↑ 发布时间",
            },
            {
              value: "desc",
              label: "↓ 发布时间",
            },
            {
              value: "asc0",
              label: "↑ 实施时间",
            },
            {
              value: "desc0",
              label: "↓ 实施时间",
            },
          ];
          this.valuesort = "desc0";
        }

        this.groupsType = [
          {
            value: "效力级别",
            label: "效力级别",
          },
          {
            value: "时效性",
            label: "时效性",
          },
          {
            value: "",
            label: "不分组",
          },
        ];
        // this.searchParameter.doc_category = "";
      }
      this.statuteList();
      this.statuteSift();
    },
    // 高级检索
    seniorCase() {
      this.$router.push({ path: "/advancedLaws" });
      window.sessionStorage.removeItem("laws");
    },
    // 修改检索精准度
    accuracy(type) {
      // console.log(type);
      this.search_Vue.type = type;
    },
    // 删除检索 / 筛选 条件
    handleClose(type, index) {
      this.regulations.splice(index, 1);
      window.sessionStorage.setItem("laws", JSON.stringify(this.regulations));
      if (this.regulations.length == 0) {
        this.searchParameter = {
          page: 1,
          pagesize: 20,
          search: "", //文本框检索
          iss_num: "", //发文字号
          pub_time: "", //发布日期
          imp_time: "", //实施日期
          timeliness: "", //时效性
          eff_level: "", //效力级别
          reg_category: "", //法规类别
          failure_basis: "", //失效依据
          content: "", //全文
          pub_department: "", //发布部门
          title: "", //标题
          thematic_class: "", //专题分类
          iss_num: "", //发文字号
          type: "", //类型：中央法规；地方法规 ;法律文书
          order: "", //排序
          doc_category: "",
        };
        this.search_Vue = { word: "", type: this.radio01, field: this.select }; //文本框检索
        // statuteList 会用 pub_time_Vue 覆盖 pub_time，末条标签关闭时必须同步清空，否则会残留发布年份
        this.pub_time_Vue = { start: "", end: "" };
      } else if (type == "Eff") {
        this.searchParameter.eff_level = "";
      } else if (type == "Pub") {
        this.searchParameter.pub_department = "";
      } else if (type == "Time") {
        // this.searchParameter.pub_time = "";
        this.pub_time_Vue = { start: "", end: "" }; //发布日期
      } else if (type == "Reg") {
        this.searchParameter.reg_category = "";
      } else if (type == "Topic") {
        this.searchParameter.thematic_class = "";
      } else if (type == "Aging") {
        this.searchParameter.timeliness = "";
      } else if (type == "doc") {
        this.searchParameter.doc_category = "";
      } else {
        this.search_Vue = { word: "", type: this.radio01, field: this.select };
      }
      this.loading_box = true;
      // this.loadNode = true;
      this.searchParameter.page = 1;
      this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
      this.statuteSift();
    },
    // 清空检索条件
    remove() {
      this.regulations = [];
      window.sessionStorage.removeItem("laws");
      this.searchParameter = {
        page: 1,
        pagesize: 20,
        search: "", //文本框检索
        iss_num: "", //发文字号
        pub_time: "", //发布日期
        imp_time: "", //实施日期
        timeliness: "", //时效性
        eff_level: "", //效力级别
        reg_category: "", //法规类别
        failure_basis: "", //失效依据
        content: "", //全文
        pub_department: "", //发布部门
        title: "", //标题
        thematic_class: "", //专题分类
        iss_num: "", //发文字号
        type: "", //类型：中央法规；地方法规 ;法律文书
        order: "", //排序
        doc_category: "",
      };
      this.search_Vue = { word: "", type: this.radio01, field: this.select }; //文本框检索
      (this.pub_time_Vue = { start: "", end: "" }), //发布日期
        (this.loading_box = true);
      // this.loadNode = true;
      this.searchParameter.page = 1;
      this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
      this.statuteSift();
    },
    // 筛选
    briefClick(data, node, item, type) {
      // console.log(data, node, item, type);
      // console.log(this.regulations);
      // let repeat = 0;
      // if (item.type == "Eff") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Pub") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Time") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Reg") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Topic") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Aging") {
      //   this.regulations.splice(index, 1);
      // }
      // this.regulations.forEach((item, index) => {
      //   // if (item.name == data.name) {
      //   //   repeat = 1;
      //   // }
      // });
      // if (repeat !== 1) {
      if (type == "Eff_level") {
        //效力级别
        let eff = {
          name: data.name,
          type: "Eff",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Eff") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(eff);
        this.searchParameter.eff_level = JSON.stringify([data.name]);
        // this.searchParameter01.eff_level = data.name;
      }
      if (type == "DocCategory") {
        //文书类型
        let doc = {
          name: data.name,
          type: "doc",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "doc") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(doc);
        this.searchParameter.doc_category = JSON.stringify([data.name]);
      }
      if (type == "Pub_Department") {
        //发布部门
        let put = {
          name: data.name,
          type: "Pub",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Pub") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(put);
        this.searchParameter.pub_department = JSON.stringify([data.name]);
      }
      if (type == "Pub_Time") {
        //发布年份
        let time = {
          name: data.key_as_string,
          type: "Time",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Time") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(time);
        // this.searchParameter.pub_time = data.key_as_string;
        this.pub_time_Vue = {
          start: data.key_as_string + "-01-01",
          end: data.key_as_string + "-12-31",
        };
      }
      if (type == "Reg_Category") {
        //法规类别
        let reg = {
          name: data.name,
          type: "Reg",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Reg") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(reg);
        this.searchParameter.reg_category = JSON.stringify([data.name]);
      }
      if (type == "Thematic") {
        //专题分类
        let topic = {
          name: data.name,
          type: "Topic",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Topic") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(topic);
        this.searchParameter.thematic_class = JSON.stringify([data.name]);
      }
      if (type == "Timeliness") {
        //时效性
        let aging = {
          name: data.key,
          type: "Aging",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Aging") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(aging);
        this.searchParameter.timeliness = JSON.stringify([data.key]);
      }
      window.sessionStorage.setItem("laws", JSON.stringify(this.regulations));
      this.loading_box = true;
      // this.loadNode = true;
      this.searchParameter.page = 1;
      this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
      this.statuteSift();
      // }
    },
    testData(data) {
      // console.log(data);
      this.briefClick(data, "", "", "Thematic");
    },

    showAll(type) {
      if (type == "Eff_level") {
        this.levelAll = true;
        this.levelShow = false;
      }
      if (type == "Pub_Department") {
        this.departmentAll = true;
        this.departmentShow = false;
      }
      if (type == "Pub_Time") {
        this.timeAll = true;
        this.timeShow = false;
      }
      if (type == "Reg_Category") {
        this.categoryAll = true;
        this.categoryShow = false;
      }
      if (type == "Thematic") {
        this.thematicAll = true;
        this.thematicShow = false;
      }
      if (type == "Timeliness") {
        this.timelinesAll = true;
        this.timelinesShow = false;
      }
      if (type == "DocCategory") {
        this.CategoryAll = true;
        this.CategoryShow = false;
      }
    },
    // 分组筛选
    packet() {
      // this.regulations = [];
      // window.sessionStorage.removeItem("laws");
      // this.searchParameter = {
      //   page: 1,
      //   pagesize: 20,
      //   search: "", //文本框检索
      //   iss_num: "", //发文字号
      //   pub_time: "", //发布日期
      //   imp_time: "", //实施日期
      //   timeliness: "", //时效性
      //   eff_level: "", //效力级别
      //   reg_category: "", //法规类别
      //   failure_basis: "", //失效依据
      //   content: "", //全文
      //   pub_department: "", //发布部门
      //   title: "", //标题
      //   thematic_class: "", //专题分类
      //   iss_num: "", //发文字号
      //   type: "", //类型：中央法规；地方法规 ;法律文书
      //   order: "", //排序
      //   doc_category: "",
      // };
      // this.search_Vue = { word: "", type: this.radio01, field: this.select }; //文本框检索
      // (this.pub_time_Vue = { start: "", end: "" }), //发布日期
      this.loading_box = true;
      // // this.loadNode = true;
      // this.searchParameter.page = 1;
      // this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
    },
    // 排序方式
    itemsort(a, b) {
      // console.log(this.valuesort);
      // console.log(a);
      if (this.valuesort !== a) {
        if (a == "") {
          this.order_vue.field = "";
        }
        if (b == "↑ 发布时间" || b == "↓ 发布时间") {
          this.order_vue.field = "Pub_Time";
          this.order_vue.type = a;
        }
        if (b == "↑ 实施时间" || b == "↓ 实施时间") {
          this.order_vue.field = "Imp_Time";
          if (a == "asc0") {
            this.order_vue.type = "asc";
          } else {
            this.order_vue.type = "desc";
          }
        }

        this.loading_box = true;
        // this.loadNode = true;
        this.searchParameter.page = 1;
        this.current_page = 1;
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
        this.statuteList();
        // this.statuteSift();
      }
    },
    //
    laws_Type() {
      if (this.searchParameter.type !== this.type_vue) {
        // this.searchParameter.type = type;
        if (this.type_vue == "法律文书") {
          this.group = "文书分类";
          this.groupsType = [
            {
              value: "文书分类",
              label: "文书分类",
            },
            {
              value: "",
              label: "不分组",
            },
          ];
          if (this.search_Vue.word !== "") {
            this.defaultsort = [
              {
                value: "",
                label: "相关度",
              },
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
            ];

            this.valuesort = "";
          } else {
            this.defaultsort = [
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
            ];
            this.valuesort = "desc";
          }
          this.order_vue.field = "Pub_Time";
          // this.searchParameter.doc_category = "法律文书";
        } else {
          this.group = "效力级别";
          if (this.search_Vue.word !== "") {
            this.defaultsort = [
              {
                value: "",
                label: "相关度",
              },
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
              {
                value: "asc0",
                label: "↑ 实施时间",
              },
              {
                value: "desc0",
                label: "↓ 实施时间",
              },
            ];
            this.valuesort = "";
          } else {
            this.defaultsort = [
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
              {
                value: "asc0",
                label: "↑ 实施时间",
              },
              {
                value: "desc0",
                label: "↓ 实施时间",
              },
            ];
            this.valuesort = "desc0";
          }

          this.groupsType = [
            {
              value: "效力级别",
              label: "效力级别",
            },
            {
              value: "时效性",
              label: "时效性",
            },
            {
              value: "",
              label: "不分组",
            },
          ];
          // this.searchParameter.doc_category = "";
        }
        // this.type_vue = type;
        this.loading_box = true;
        this.loadNode = true;
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
        this.statuteList();
        this.statuteSift();
      }
    },
    moreLevel(allName) {
      // console.log(allName);
      if (this.group == "效力级别") {
        let eff = {
          name: allName,
          type: "Eff",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Eff") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(eff);
        this.searchParameter.eff_level = JSON.stringify([allName]);
      } else if (this.group == "时效性") {
        let aging = {
          name: allName,
          type: "Aging",
        };
        this.regulations.push(aging);
        this.searchParameter.timeliness = JSON.stringify([allName]);
      } else {
      }
      this.loading_box = true;
      this.statuteList();
    },
    // 切换列表 、 可视化
    dataType(type) {
      // this.picked = !this.picked;
      if (type == "list") {
        if (this.picked == true) {
          this.picked = false;
          this.sortShow = false;
        }
      }
      if (type == "chart") {
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
      }
    },
    collectible(it) {
      console.log(it, this.categoryList);
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          // user_id: store.getCookie("user_id"),
          docid: it._id,
          // role: store.getCookie("role"),
          doctype: 3,
          docname: it._source.Title,
        };
        this.$http
          .post("/coll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            // this.statuteList();
            for (let a = 0; a < this.categoryList.length; a++) {
              for (let i = 0; i < this.categoryList[a].list.hits.length; i++) {
                if (it._id == this.categoryList[a].list.hits[i]._id) {
                  if (this.categoryList[a].list.hits[i]._source.coll == 0) {
                    this.$set(
                      this.categoryList[a].list.hits[i]._source,
                      "coll",
                      1
                    );
                    // this.categoryList[a]._source.coll=1
                    console.log(this.categoryList[a].list.hits[i]._source.coll);
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    cancel(it) {
      // console.log("a");
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          docid: it._id,
        };
        this.$http
          .post("/delcoll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            // this.statuteList();
            for (let a = 0; a < this.categoryList.length; a++) {
              for (let i = 0; i < this.categoryList[a].list.hits.length; i++) {
                if (it._id == this.categoryList[a].list.hits[i]._id) {
                  if (this.categoryList[a].list.hits[i]._source.coll == 0) {
                    this.$set(
                      this.categoryList[a].list.hits[i]._source,
                      "coll",
                      1
                    );
                    // this.categoryList[a]._source.coll=1
                    console.log(this.categoryList[a].list.hits[i]._source.coll);
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    // 单篇下载
    down(id, type) {
      // console.log(id, type);
      if (type == "word") {
        this.$http
          .get("/law/word?id=" + id, {})
          .then((res) => {
            // console.log(res);
            // window.open(res.data.data.url, "_blank");
            if (res.data.data.url) {
              window.open(res.data.data.url, "_blank");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (type == "pdf") {
        this.$http
          .get("/law/pdf?id=" + id, {})
          .then((res) => {
            // console.log(res);
            // window.open(res.data.data.url, "_blank");
            if (res.data.data.url) {
              window.open(res.data.data.url, "_blank");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.searchParameter.page = val;
      this.current_page = val;
      this.loading_box = true;
      this.statuteList();
      window.scrollTo(0, 0);
    },
    reloads() {
      // 移除组件
      this.update = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.update = true;
      });
    },
    showEeharts() {
      var chart1 = this.$echarts.init(this.$refs.chart1);
      // console.log(this.wordData);
      let words = [];
      this.Thematic.forEach((item) => {
        let word = {
          name: item.name,
          value: item.count,
        };
        words.push(word);
      });

      var chart1Option = {
        title: {
          // text: '各省累计确诊-词云',//标题
          x: "center",
          textStyle: {
            fontSize: 10,
          },
        },
        // backgroundColor: "#fff", //F7F7F7
        tooltip: {
          show: true,
        },
        series: [
          {
            name: "关键词", //数据提示窗标题
            type: "wordCloud",
            sizeRange: [10, 12],
            // rotationRange: [-90, 90],
            rotationRange: [0, 0, 0, 0],
            // maskImage: maskImages,
            shape: "pentagon",
            width: "80%",
            height: "100%",
            drawOutOfBound: false,
            textStyle: {
              normal: {},
              color: function () {
                return (
                  "rgb(" +
                  [
                    Math.round(Math.random() * 200),
                    Math.round(Math.random() * 200),
                    Math.round(Math.random() * 200),
                  ].join(",") +
                  ")"
                );
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            left: "center",
            top: "center",
            right: null,
            bottom: null,
            width: "200%",
            height: "200%",
            data: words,
          },
        ],
      };
      chart1.setOption(chart1Option);

      let that = this;
      chart1.on("click", function (params) {
        let data = {
          name: params.data.name,
          count: params.data.value,
        };
        that.briefClick(data, "", "", "Thematic");
        // 	var name = params.data.name;
        // 	var value = params.data.value;
        // var uniscid = params.data.uniscid;
        // 	console.log(name + ":" + value + ":" + uniscid);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.background_box {
  // background: #f3ede3;
  background: rgb(245, 239, 228);
  min-width: 1350px;
}

.laws_statute {
  width: 100%;
  background: url("../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 1000px;
  // background-repeat: no-repeat;
  // max-width: 1920px;
  margin: auto;

  .case {
    width: 1350px;
    min-width: 1350px;
    max-width: 1350px;
    margin: auto;
    min-height: calc(100vh - 60px);

    .breadcrumb {
      margin: 20px 0;
    }

    .advanced_search {
      // margin-left: ;
      display: flex;
      justify-content: center;

      .carousel {
        padding: 10px 20px 20px 10px;
        border-radius: 10px;
        // width: 20%;
        height: 150px;
        background: none !important;

        /deep/ .el-carousel__button {
          width: 10px;
        }

        .el-carousel__item h3 {
          display: inline-block;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #475669;
          font-size: 14px;
          opacity: 0.75;
          // line-height: 50px;
          margin: 0;

          span {
            display: inline-block;
          }
        }

        .el-carousel__item:nth-child(2n) {
          // background-color: #99a9bf;
          background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
          background-size: 100% 100%;
        }

        .el-carousel__item:nth-child(2n + 1) {
          // background-image: url('../../../assets/imgs/背景图/9760eac49571416.jpg');
          background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
          background-size: 100% 100%;
        }
      }

      .el-tabs {
        width: 79%;

        .el-tab-pane {
          .el-popover {
          }

          .el-input {
            // height: 20px;
            /deep/ .el-input__inner {
              // border-radius: 0;
            }
          }

          .el-button {
            margin: 0;
            border: 0;
            // border-radius: 0;
          }
        }
      }

      /deep/ .el-popover--plain {
        margin-left: 700px;
      }
    }
  }
}

.conditions {
  display: flex;
  line-height: 32px;
  justify-content: space-between;
  margin: 10px 0;

  .condition {
    position: relative;

    .eltags {
      display: inline-block;
      max-width: 610px;
      margin-left: 60px;
    }

    .el-tag {
      margin: 0 0 5px 5px;
    }
  }

  .savebtn :hover {
    color: #409eff;
    cursor: pointer;
  }
}

.box_botton {
  display: flex;

  .box_left {
    width: 20%;
    max-width: 20%;
    padding: 0 10px 10px 0px;
    margin-right: 1%;
    border-radius: 5px;
    margin-bottom: 2%;

    /deep/ .el-menu {
      // padding: 0 0px 0px 10px;
      // background: white;
      // border: none;
      // border-radius: 10px;
      background: #faf1e8 !important;
      background-color: #faf1e8 !important;
      border: none;
      border-radius: 10px;
    }

    /deep/ .el-submenu {
    }

    h2 {
      margin: 10px 0;
      font-weight: 600;

      span {
        font-size: 28px;
        color: chocolate;
        font-weight: 600;
      }
    }
  }

  .box_right {
    width: 80%;
    position: relative;
    top: -20px;
  }
}

// 查看更多 样式
.more {
  cursor: pointer;
  color: #409eff;
  background: #faf1e8 !important;
  height: 30px;
  width: 100%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
}

// 侧边筛选高度
.sift_tree::-webkit-scrollbar {
  display: none;
}

.sift_tree {
  max-height: 450px;
  overflow-x: hidden;
  // overflow-y: scroll;
}

.box_right {
  width: 80%;

  // background: white;
  .box_right_top {
    padding: 10px;
    // background: white;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;

    .el-select {
      width: 110px;
      height: 10px;
      color: violet !important;
    }
  }

  .types {
    .listPick {
      // color: #409eff;
      // background: #ecf5ff;
      // border-color: #b3d8ff;
      // border-radius: 4px;
      color: #ddb361;
      background: #faf1ea;
      border-color: #ddb361;
    }

    .EChart {
      background: none !important;
    }

    .el-button:hover {
      // color: #409eff;
      // border-color: #c6e2ff;
      // background-color: #ecf5ff;
      color: #ddb361;
      background: #faf1ea;
      border-color: #ddb361;
    }
  }

  .box_main {
    // margin-top: 20px;

    .box_main_list {
      // margin: 10px 0 20px 0px;
      margin: 10px 0 20px 0px;
      // height: 200px;
      // height: 300px;
      border-radius: 5px;
      padding: 10px;
      background: #fbf2eb;

      .title {
        position: relative;

        display: flex;
        justify-content: space-between;
        // margin-bottom: 10px;
        line-height: 28px;

        h2 {
          font-size: 16px;
          font-weight: 600;
          // margin-left: 200px;
        }

        .el-tag {
          margin: 0 0px 0 25px;
          position: absolute;
          top: 0px;
        }
      }

      .title :hover {
        // color: rgb(197, 197, 197);
        color: #cf8700;
      }

      .case {
        background: #cf8700;
        color: white;
        // display: inline-block;
        margin: 5px;
        // padding: 5px;
        border-radius: 5px;
      }

      .card {
        margin: 20px 0 0 0;

        .mores {
          display: flex;
          justify-content: center;

          span {
            display: inline-block;
            cursor: pointer;
          }
        }

        p {
          line-height: 20px;
          overflow: hidden;
          -webkit-line-clamp: 5;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }

        .hits {
          // line-height: 30px;
          display: flex;

          span {
            // display: inline-block;
            line-height: 25px !important;
          }
        }

        /deep/ .el-tabs__content {
          // background: #f0e1d5;
          background: #fbf2eb;
        }

        /deep/ .el-tabs__nav-scroll {
          .el-tabs__item.is-active {
            color: #ddb361;
            // background: #f0e1d5;
            background: #fbf2eb;
            border-right-color: #dcdfe6;
            border-left-color: #dcdfe6;
          }
        }

        /deep/ .el-tabs__nav-wrap {
          // background: #fbf2eb;
          background: #f0e1d5;
        }
      }

      .box_detail {
        margin-top: 10px;
        // height: 200px;
        background: #f0e1d5;
        padding: 18px;

        .basic {
          margin-bottom: 30px;
          font-size: 16px;
          display: flex;

          .basic_left {
            width: 15%;
            height: 56px;
            display: inline-block;
            padding: 20px 20px 10px 20px;
            border-right: 1px solid rgb(172, 112, 0);
          }

          .basic_right {
            width: 85%;
            padding-left: 10px;

            .basic_content {
              // min-width: 500px;
              // div {
              //   // display: block;
              //   line-height: 30px;
              // }
              width: 50%;

              div {
                // display: block;
                line-height: 30px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }

            // justify-content: space-around;
            // width: 500px;
            // p {
            //   // display: inline-block;
            //   height: 20px;
            //   line-height: 20px;
            //   min-width: 45%;
            //   // max-width: 50%;
            //   // margin: 5px;
            // }
          }

          .details {
            width: 85%;
            padding-left: 10px;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;

            p {
              line-height: 20px;
            }
          }
        }

        .card {
          margin: 20px 0 0 0;

          .mores {
            display: flex;
            justify-content: center;

            span {
              display: inline-block;
              cursor: pointer;
            }
          }

          p {
            line-height: 20px;
            overflow: hidden;
            -webkit-line-clamp: 5;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }

          .hits {
            // line-height: 30px;
            display: flex;

            span {
              // display: inline-block;
              line-height: 25px !important;
            }
          }

          /deep/ .el-tabs__content {
            // background: #f0e1d5;
            background: #fbf2eb;
          }

          /deep/ .el-tabs__nav-scroll {
            .el-tabs__item.is-active {
              color: #ddb361;
              // background: #f0e1d5;
              background: #fbf2eb;
              border-right-color: #dcdfe6;
              border-left-color: #dcdfe6;
            }
          }

          /deep/ .el-tabs__nav-wrap {
            // background: #fbf2eb;
            background: #f0e1d5;
          }
        }

        .detail {
        }
      }
    }
  }
}

.mores {
  display: flex;
  justify-content: center;
  margin: 20px 0 0 0;

  span {
    display: inline-block;
    color: #e6a23c;
  }

  span:hover {
    color: #3ca2e6;
    cursor: pointer;
  }
}

// 列表操作功能
.el-dropdown-link {
  cursor: pointer;
}

.el-dropdown-link:hover {
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

// 分页按钮
.page-bar {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

.message {
  display: flex;
  justify-content: space-between;

  /deep/ .el-breadcrumb__item {
    display: inline-block;
    line-height: 28px;
  }
}

.imgTitle {
  // margin: 0 10px;
  position: relative;
  // left: -20px;
}

.grouping-title {
  position: relative;
  height: 40px;
  padding: 5px 0 5px 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  background: #f0e1d5;

  h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    cursor: pointer;
    color: #e6a23c;
    float: left;
    display: inline-block;
  }

  span {
    font-size: 15px;
    line-height: 30px;
    color: #666;
    position: absolute;
    right: 20px;
  }
}

.more {
  text-align: center;
  margin-bottom: 20px;

  // color: #666;
  i {
    font-size: 30px;
    margin: 0 10px 0 0;
  }
}

.more:hover {
}

/deep/ .el-icon-view {
  font-size: 20px;
  position: relative;
  top: 3px;
}

.packMore {
  color: #666;
}

.packMore:hover {
  color: #e6a23c;
  cursor: pointer;
}

/deep/ .el-tree-node__content {
  // margin: 5px 15px 5px 0;
  // min-height: 40px;
}

.region {
  /deep/ .el-tree-node {
    white-space: normal;
    // padding: 10px 0;
    // max-width: 170px;
    // line-height: 25px;
    // text-align: center;

    .el-tree-node__content {
      height: 100%;
      align-items: start;
      line-height: 30px;
    }

    // .el-tree-node__content {
    //   height: 100%;
    //   align-items: start;
    // }
  }
}

.cityClass {
  /deep/ .el-tree-node__content {
    // height: 60px;
    // max-height: 60px !important;
    // display: inline-block;
    // margin: 5px 5px 5px 0;
  }

  /deep/ .custom-tree-node {
    // display: inline;
    padding-right: 10px;
  }

  /deep/ .custom-tree-node {
    // margin: 10px 0;
    // padding-right: 10px;
    // width: 150px;

    // display: inline-block;
    // max-height: 50px;
  }
}

.collection {
  img {
    width: 28px;
  }
}

.collection:hover img {
  cursor: pointer;
  // content: url("../../../assets/imgs/2.0/收藏3.png");
}

// .carousel::-webkit-scrollbar {
//   display: none;
// }
.carousel {
  padding: 20px 20px 20px 10px;
  border-radius: 10px;
  // width: 20%;
  // min-width: ;
  // height: 150px;
  height: 150px;
  background: none !important;

  // overflow-x: hidden;
  //   overflow-y: scroll;
  /deep/ .el-carousel__button {
    width: 10px;
  }

  .el-carousel__item h3 {
    display: inline-block;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    // line-height: 50px;
    margin: 0;

    span {
      display: inline-block;
    }
  }

  .el-carousel__item:nth-child(2n) {
    // background-color: #99a9bf;
    background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
    background-size: 100% 100%;
  }

  .el-carousel__item:nth-child(2n + 1) {
    // background-image: url('../../../assets/imgs/背景图/9760eac49571416.jpg');
    background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
    background-size: 100% 100%;
  }
}

.tit_input {
  /deep/ .el-input-group__append {
    border: none;
  }

  /deep/ .el-input-group__prepend {
    border: none;
  }

  /deep/ .el-input__inner {
    border: none;
    border-start-start-radius: 0px;
    border-end-start-radius: 0px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    // background: #fef7f0;
    background: #f7f1eb;
    border-right: #b7a974 1px solid;
    border-top: #b7a974 1px solid !important;
    border-bottom: #b7a974 1px solid;
    position: relative;
    top: 0px;
    height: 43px;
  }
}

.search_button {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
  border-end-end-radius: 4px;
  border-start-end-radius: 4px;
}

.titSelect {
  // background: #fef7f0;
  background: #f7f1eb;
  height: 43px;
  // border: none;
  border-left: #b7a974 1px solid;
  // border-top: #b7a974 1px solid !important;
  border-bottom: #b7a974 1px solid;
  border-start-start-radius: 4px;
  border-end-start-radius: 4px;
  border-end-end-radius: 0px;
  border-start-end-radius: 0px;

  /deep/ .el-input__inner {
    text-align: center;
    // border-radius: 0;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
  }

  /deep/ .el-input__suffix-inner {
    // display: inline-block;
    // border: none;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    padding: 0 15px;
    // margin-top: 5px;
    position: relative;
    top: 2px;
    border-right: 1px #e8e3dd solid;

    i {
      position: relative;
      top: -2px;
    }
  }
}

/deep/ .wor {
  /deep/ div {
    /deep/ canvas {
      border-radius: 50px;
    }
  }
}

/deep/ .el-tree-node__expand-icon {
  position: relative;
  top: 3px;
}

.el-tree {
  background: #faf1e8;
}

.bac {
  /deep/ .el-input__inner {
    background: none;
  }

  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #030303;
  }

  // /deep/ .el-select /deep/ .el-input.is-focus /deep/ .el-input__inner {
  //   border-color: #dcdfe6;
  // }
  /deep/ .el-input.is-focus {
    border-color: #dcdfe6;
  }
}

.sift_tree
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-checked
  > .el-tree-node__content {
  background-color: rgb(247, 26, 26);
  color: rgb(156, 65, 53);
}

.sift_tree
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: rgb(255, 10, 10);
  color: rgb(195, 64, 255);
}

/deep/ .el-tree-node__content:hover {
  /*设置鼠标飘过的颜色 */
  // background: #eaf9ff !important;
  color: #e6a23c !important;

  background: none !important;

  .custom-tree-node {
    span {
      // font-weight: 900 !important;
    }
  }
}

.sift_tree {
  /deep/ .el-tree-node:focus > .el-tree-node__content {
    /*设置选中的样式 */
    // background-color: #dde9ff !important;
    background: none !important;
  }

  /deep/ .el-tree-node__content {
    /*设置选中的样式 */
    // background-color: #dde9ff !important;
    background: none !important;
    // color: #e6a23c  !important;
  }

  /deep/ .el-tree-node__content:hover {
    /*设置鼠标飘过的颜色 */
    // background: #eaf9ff !important;
    color: #e6a23c !important;

    background: none !important;

    .custom-tree-node {
      span {
        // font-weight: 900 !important;
      }
    }
  }

  /deep/ .el-tree-node__label {
  }

  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    /*current选中的样式 */
    color: #e4b453;
    font-weight: bold;
    background: none !important;
    // background-color: #dde9ff !important;
  }

  /deep/ .custom-tree-node {
    // display: inline-block;
    padding-right: 10px;
  }
}

.box_left {
  /deep/ .el-submenu__title:hover {
    color: #e4b453;
    background: none !important;
  }
}

.down_icon {
  width: 20px;
  position: relative;
  top: 3px;
}

.radio_css {
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #cf8700;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: #e6a23c;
    border-color: #e6a23c;
  }
}
</style>